import { MultiSelect } from 'components';
import { groupListforDevice } from 'features/Integrations/utils/deviceGroupRulesUtils';
import React from 'react';

const DeviceGroupsSelect = ({ deviceTypes, formData, setFormData, deviceGroups }) => {
  // `system_type` / `device_type` hold the type names themselves, not dropdown
  // indexes, so the selected type is resolved by name (as renderValidDevice does).
  const selectedType = deviceTypes
    ?.find((sys) => sys.system_type === formData?.system_type)
    ?.device_types?.find((type) => type.type === formData?.device_type)?.type;

  const options = groupListforDevice(selectedType, deviceGroups || []).map((group) => ({
    name: group.name,
    value: group.id,
  }));

  return (
    <div className="d-flex flex-column border border-1 p-2 rounded-2 mt-2">
      <MultiSelect
        label="Device Groups"
        options={options}
        value={formData.groups || []}
        onChange={(value) => setFormData({ ...formData, groups: value })}
      />
    </div>
  );
};

export default DeviceGroupsSelect;
